import { useEffect } from 'react';

/**
 * Dynamically sets CSS variables on the given element.
 * @param {React.MutableRefObject<any>} ref The element ref that you wish to change the variables of.
 * @param {Record<string, string>} values An object with key-value pairs of variable names and value.
 */
const useCssVariables = (ref, values) => {
  useEffect(() => {
    if (!ref.current) return;

    Object.entries(values).forEach(([variableName, value]) => {
      if (!value) return;

      ref.current.style.setProperty(variableName, value);
    });
  }, [ref, values]);
};

export default useCssVariables;
